module.exports = __webpack_public_path__ + "img/check_btn.0d0e7f11.svg";